function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.001 13C22.001 11.42 21.126 10.05 19.853 9.4C20.007 8.965 20.091 8.495 20.091 8C20.091 5.79 18.381 4.002 16.273 4.002C15.803 4.002 15.353 4.086 14.937 4.252C14.319 2.915 13.011 2 11.501 2C9.991 2 8.685 2.917 8.064 4.25C7.649 4.085 7.198 4 6.728 4C4.618 4 2.91 5.79 2.91 8C2.91 8.494 2.993 8.964 3.147 9.4C1.875 10.05 1 11.418 1 13C1 14.495 1.782 15.798 2.942 16.486C2.922 16.656 2.91 16.826 2.91 17C2.91 19.21 4.618 21 6.728 21C7.198 21 7.648 20.914 8.063 20.75C8.683 22.084 9.989 23 11.5 23C13.012 23 14.318 22.084 14.937 20.75C15.352 20.913 15.802 20.998 16.273 20.998C18.383 20.998 20.091 19.208 20.091 16.998C20.091 16.824 20.079 16.654 20.058 16.485C21.216 15.798 22.001 14.495 22.001 13.001V13ZM14.9186 9L16 10.0769L10.0522 16L10.0521 15.9999L8.97075 14.9231L7 12.9605L8.08142 11.8836L10.0522 13.8461L14.9186 9Z",
  fill: "#03363D"
});

var SvgVerified = function SvgVerified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Verified.cd344dee.svg";
export { ForwardRef as ReactComponent };